import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import ScanUsersTable from './ScanUsersTable';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCompanyScanUsers } from './companyScanApi';

/**
 * Company Scans → Employees/Members list.
 * Every user of the current population appears (those who have never scanned
 * show dashes and sort last); a row opens their scan history.
 */
const CScanUsers = () => {
  const navigate = useNavigate();
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const fetcher = useCallback(
    (params) => fetchCompanyScanUsers({ ...params, department }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Scans — {isB2BFansMode ? 'Members' : 'Employees'} | Shoorah</title>
      </Helmet>

      <p className="text-sm text-gray-500 dark:text-gray-400 mb-3">
        Your {isB2BFansMode ? 'members' : 'employees'} and the scans they have taken. Open a user to
        see when they scanned and whether it worked — never what it found.
      </p>

      <ScanUsersTable
        fetcher={fetcher}
        onOpenUser={(rowData) => navigate(`/${slug}/scans/user?userId=${rowData?._id}`)}
        tableName="company_scan_users"
      />
    </div>
  );
};

export default CScanUsers;
